import { SkinProductOption } from '../types/productTypes'
import { getSkinSlotCount, getTopLevelMenuCategoryForProduct } from '../products/productUtils'
import { SelectorScreenMenuType } from './SelectorScreenMenuType'

/**
 * generates a filter against the selected product
 * keeps all products except alternative grid options for the selected product
 * @param selectedProduct
 * @param products
 */
export function filterByBaseItemNoAndColor(selectedProduct: SkinProductOption, products: SkinProductOption[]) {
  const itemNo = selectedProduct.gridProduct?.itemNo
  const baseItemNo = selectedProduct.gridProduct?.baseItemNo
  const selectedItemType = selectedProduct.type
  const selectedItemColor = selectedProduct.color
  const selectedItemOrientation = selectedProduct.orientation

  const addedBaseNos: string[] = []

  return products.filter((item: SkinProductOption) => {
    // show all products with no grid or base grid no.
    if (!item.gridProduct) {
      return true
    }

    if (!item.gridProduct.baseItemNo) {
      return true
    }

    // hide a product if it matches the selected product's base item no., color and type, but isn't the selected product
    if (
      baseItemNo
      && baseItemNo === item.gridProduct.baseItemNo
      && selectedItemType === item.type // handle night walk, etc
      && selectedItemColor === item.color
      && selectedItemOrientation === item.orientation
      && itemNo !== item.gridProduct.itemNo
    ) {
      return false
    }

    const key = `${item.gridProduct.baseItemNo} ${item.color?? ''}`

    // only show 1 product for each color / base item no. combination
    if (!addedBaseNos.includes(key)) {
      addedBaseNos.push(key)
      return true
    }

    // default case: base item no has already been seen
    return false
  })
}

export function doesProductPartialMatch(selectedProduct: SkinProductOption, otherProduct: SkinProductOption, expandedMenu: SelectorScreenMenuType, fields: ('color' | 'style' | 'orientation' | 'type' | 'slots' | 'sockets' | 'has-slots')[]) {
  const nonMatch = fields.findIndex(field => {
    if (field === 'slots') {
      return (getSkinSlotCount(selectedProduct)) !== (getSkinSlotCount(otherProduct))
    }

    if (field === 'sockets') {
      return (selectedProduct.gridProduct?.socketNo ?? 0) !== (otherProduct.gridProduct?.socketNo ?? 0)
    }

    if (field === 'has-slots') {
      return (getSkinSlotCount(selectedProduct) === 0)
        !== (getSkinSlotCount(otherProduct) === 0)
    }

    if (field === 'type') {
      return (getTopLevelMenuCategoryForProduct(selectedProduct, expandedMenu) !== getTopLevelMenuCategoryForProduct(otherProduct, expandedMenu))
    } else {
      return selectedProduct[field] !== otherProduct[field]
    }
  })

  return nonMatch === -1
}
